/**
 * Mise en page de l'arborescence des reglements.
 *
 * CE QUI EST ICI, ET CE QUI N'Y EST PLUS. Le rattachement - quelle operation
 * depend de laquelle - est une donnee du dossier : il arrive desormais construit
 * par le serveur, dans `operations`. Ce module ne s'occupe plus que du DESSIN :
 * a quelle profondeur poser chaque ligne, laquelle termine sa fratrie, et
 * jusqu'ou descendent les filets verticaux. Ce sont des questions d'affichage,
 * elles n'ont rien a faire sur un serveur.
 *
 * Auparavant ce fichier reconstruisait l'arbre a partir des seuls
 * `parentCodeId`, et l'ecran d'avant le reconstruisait a PLAT : l'annulation
 * d'un reglement comptable ressortait a cote de ce comptable, comme sa soeur,
 * alors qu'elle en depend.
 */

/**
 * Les operations d'un reglement, pretes a etre rendues ligne par ligne.
 *
 * @param {Array} operations Les operations rattachees, chacune portant les
 *   siennes dans `operations`. C'est la forme que renvoie le serveur.
 * @returns {Array} Une ligne par operation, dans l'ordre d'affichage :
 *   - `operation` : l'operation elle-meme
 *   - `parent`    : son parent direct, ou null au premier niveau
 *   - `niveau`    : 1 pour les enfants de la racine, 2 pour les leurs, etc.
 *   - `derniere`  : derniere de sa fratrie - le filet vertical s'arrete a elle
 *   - `traits`    : pour chaque niveau au-dessus, si le filet de cet ancetre
 *                   doit continuer a descendre le long de cette ligne
 */
export function aplatirOperations(operations) {
    const sortie = [];

    const descendre = (fratrie, parent, niveau, traits) => {
        const lignes = fratrie || [];
        lignes.forEach((operation, rang) => {
            const derniere = rang === lignes.length - 1;
            sortie.push({ operation, parent, niveau, derniere, traits });
            descendre(
                operation.operations,
                operation,
                niveau + 1,
                // Le filet de CETTE ligne continue sous ses enfants sauf si elle
                // est la derniere de sa fratrie : sinon il descendrait dans le vide.
                [...traits, !derniere],
            );
        });
    };

    descendre(operations, null, 1, []);
    return sortie;
}

/**
 * L'arbre remis a plat, racines comprises.
 *
 * POURQUOI CETTE LISTE EXISTE ENCORE. Le tableau a besoin de l'arbre, mais la
 * recherche, l'export et les compteurs de statuts ont besoin de TOUTES les
 * lignes sans distinction de profondeur. La deriver de l'arbre plutot que de
 * demander les deux au serveur garantit qu'elles ne peuvent pas diverger.
 */
export function aplatirEnListe(reglements) {
    const sortie = [];
    const descendre = (noeuds) => {
        (noeuds || []).forEach((noeud) => {
            sortie.push(noeud);
            descendre(noeud.operations);
        });
    };
    descendre(reglements);
    return sortie;
}
